import ListButton from "@/components/list-button"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { sessionEditUserOptions } from "@/redux/_session.actions"
import { userUpdateOptions } from "@/redux/user.actions"
import { UserOptions } from "@/redux/user.types"
import { faList, faTableCellsLarge } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"

export type RiskFamiliesDisplayMode = "grid" | "list"

export default function RisksUserSettings() {
  const dispatch = useAppDispatch()
  const userId = useAppSelector((state) => state._session.userId)
  const userOptions = useAppSelector((state) => state._session.userOptions)
  const displayMode = userOptions.risksFamiliesDisplayMode ?? "grid"
  const [isSaving, setIsSaving] = useState(false)

  async function setDisplayMode(nextDisplayMode: RiskFamiliesDisplayMode) {
    if (isSaving || nextDisplayMode === displayMode) return

    const nextOptions = new UserOptions({
      ...userOptions,
      risksFamiliesDisplayMode: nextDisplayMode
    })

    setIsSaving(true)
    dispatch(sessionEditUserOptions("risksFamiliesDisplayMode", nextDisplayMode))

    try {
      await dispatch(userUpdateOptions(userId, nextOptions))
    } finally {
      setIsSaving(false)
    }
  }

  const nextDisplayMode = displayMode === "grid" ? "list" : "grid"

  return (
    <div className="shrink-0">
      <ListButton
        icon={nextDisplayMode === "list" ? faList : faTableCellsLarge}
        text={nextDisplayMode === "list" ? "Affichage liste" : "Affichage mosaïque"}
        isPrimary={displayMode === "list"}
        isInactive={isSaving}
        onClick={() => setDisplayMode(nextDisplayMode)}
      />
    </div>
  )
}
